<template>
	<v-tooltip top color="black">
		<template #activator="{ on, attrs }">
			<v-avatar
				:color="corBackground"
				size="21"
				:style="{ backgroundColor: corBackground }"
				class="estilo-avatar me-3 white--text"
				v-bind="attrs"
				v-on="on"
			>
				{{ labelBotao }}
			</v-avatar>
		</template>
		<span>{{ texto }}</span>
	</v-tooltip>
</template>
<script>
export default {
	name: 'icone-simples-redondo-com-label',
	props: {
		labelBotao: {
			type: String,
			required: true,
		},
		corBackground: {
			type: String,
			required: true,
		},
		texto: {
			type: String,
			required: true,
		},
	},
}
</script>
<style lang="stylus" scoped>
.tamanho-texto-titulo
	font-size 15px !important
	font-weight: bold

.estilo-avatar
	font-size 10px !important
	font-weight bold
	color black
</style>
